import firebase from 'firebase/app';
import "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const auth = firebase.initializeApp ({
    apiKey: "AIzaSyB88OANtmjHBklBOICihVcVJEP1nzQF1fw",
    authDomain: "frendz-21285.firebaseapp.com",
    projectId: "frendz-21285",
    storageBucket: "frendz-21285.appspot.com",
    messagingSenderId: "54481053154",
    appId: "1:54481053154:web:55949b66b33439459005bb"
    // measurementId: "G-FPSJV8KT1Y"
  }).auth( );